var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 6.66667C1.33331 6.66667 1.41419 6.10051 3.75734 3.75736C6.10048 1.41421 9.89947 1.41421 12.2426 3.75736C13.0728 4.58754 13.6089 5.60048 13.8508 6.66667M14.6666 9.33333C14.6666 9.33333 14.5858 9.8995 12.2426 12.2426C9.89947 14.5858 6.10048 14.5858 3.75734 12.2426C2.92716 11.4125 2.39111 10.3995 2.1492 9.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 13.3327V9.33268H10.6666M1.33331 2.66602V6.66602H5.33331",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/IconRefresh.d21c8a84a225dc2f240a4136d3ed81c9.svg";
export { ForwardRef as ReactComponent };